export default __webpack_public_path__ + "static/media/software.5069fa04.svg";